"use strict";

define('rs/form/formobjects/base.formobject.view',['require','exports','module','vertebrae','rs/helper','jquery'],function (require, exports, module) {
  var Vertebrae = require('vertebrae');
  var helper = require('rs/helper');
  var $ = require('jquery');
  var FRAGMENT_CLASS = 'form-object-diff-fragment';
  var AbstractFormObjectView = Vertebrae.View.extend({
    properties: ['formElement', 'labelElement', 'textElement', 'descriptionElement', 'helpTextElement'],
    events: {
      'click > .form-object-controls .trash': 'handleDeleteClick',
      'click > .form-object-controls .settings': 'handleSettingsClick',
      'click > .form-object-contents .comment-container': 'handleCommentContainerClick',
      'click > .comment-container': 'handleCommentContainerClick',
      'click > .btn-add-compound': 'handleAddCompoundClick',
      'keydown > .form-object-controls .trash': 'handleDeleteKeydown',
      'keydown > .btn-add-compound': 'handleAddCompoundKeydown',
      'keydown > .form-object-contents .helptext-button': 'handleHelpKeydown',
      'keydown': 'handleFormDiffKeydown',
      'keydown > .form-object-contents .comment-container': 'handleCommentContainerKeyDown',
      'keydown > .comment-container': 'handleCommentContainerKeyDown'
    },
    templates: {
      'formobject.init': 'renderBaseFormObjectFragment',
      'form.dropcontrols': 'renderDropControlsFragment',
      'comment.count': 'renderCommentCountFragment',
      'formobject.content': 'renderFormObjectContent'
    },
    initialize: function initialize() {
      Vertebrae.View.prototype.initialize.apply(this, arguments);
      this.once('change:delegate', function (delegate) {
        delegate.elementId = 'fo-' + delegate.getId();
        delegate.getElementId = function () {
          return delegate.elementId;
        };
      });
    },
    setElement: function setElement(el) {
      helper.datum(el, this);
      return this._super.apply(this, arguments);
    },
    handleDropEnter: function handleDropEnter() {
      this.$el.addClass('drop-hover');
    },
    handleDropExit: function handleDropExit() {
      this.$el.removeClass('drop-hover');
    },
    createChildElement: function createChildElement(noAppend) {
      var container = $('<div />');
      if (noAppend !== true) {
        if (this.isDesignerMode()) {
          this.getChildContainer().find(".form-object-spacer.last-internal").before(container);
        } else {
          this.getChildContainer().append(container);
        }
      }
      return container;
    },
    _getPreviousDiffObjectTabTargets: function _getPreviousDiffObjectTabTargets() {
      var $tabEntrancePoint = $('#nextDiffButton');
      var $nextDiffView = $('#' + this.$el.attr('id').substr(5));
      var $previousDiffView = $nextDiffView.prev('.form-object-diff-fragment');
      return {
        previous: $previousDiffView.length !== 0 ? $previousDiffView : $tabEntrancePoint,
        next: $nextDiffView
      };
    },
    _getCurrentDiffObjectTabTargets: function _getCurrentDiffObjectTabTargets() {
      var $tabExitPoint = $('.skip-link');
      var isAttachment = isAttachment = this.getDelegate().getType() === 'attachment';
      var $compareButton = this.$el.find('.compare-button');
      var $previousDiffView = $('#prev-' + this.$el.attr('id'));
      var $nextDiffView = isAttachment && !(document.activeElement === $compareButton.get(0)) ? $compareButton : $previousDiffView.next('.form-object-diff-fragment');
      return {
        previous: $previousDiffView,
        next: $nextDiffView.length !== 0 ? $nextDiffView : $tabExitPoint
      };
    },
    _isDiffedFormObject: function _isDiffedFormObject() {
      return this.$el.hasClass('form-object-diff-fragment');
    },
    _isPreviousFormObjectView: function _isPreviousFormObjectView() {
      return this.$el.attr('id').indexOf('prev-') !== -1;
    },
    handleFormDiffKeydown: function handleFormDiffKeydown(ev) {
      var tabTargets;
      if (!this._isDiffedFormObject()) {
        return;
      }
      ev.preventDefault();
      tabTargets = this._isPreviousFormObjectView() ? this._getPreviousDiffObjectTabTargets() : this._getCurrentDiffObjectTabTargets();
      if (ev.keyCode === 9 && !ev.shiftKey) {
        if (tabTargets.next) {
          tabTargets.next.focus();
        }
      }
      if (ev.keyCode === 9 & ev.shiftKey) {
        if (tabTargets.previous) {
          tabTargets.previous.focus();
        }
      }
    },
    handleAddCompoundKeydown: function handleAddCompoundKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleAddCompoundClick(ev);
      }
    },
    handleAddCompoundClick: function handleAddCompoundClick(ev) {
      this.getDelegate().requestAddCompoundChildren();
    },
    isDesignerMode: function isDesignerMode() {
      return this.getDelegate().isDesignerMode();
    },
    getExtraContent: function getExtraContent() {
      return false;
    },
    progressiveDisclosureEnabled: function progressiveDisclosureEnabled() {
      return this.getDelegate().getFormController().progressiveDisclosureEnabled();
    },
    show: function show() {
      if (this.progressiveDisclosureEnabled()) {
        if (this._animate) {
          this.$el.slideDown();
        } else {
          this.$el.show();
        }
      }
    },
    hide: function hide() {
      if (this.progressiveDisclosureEnabled()) {
        if (this._animate) {
          this.$el.slideUp();
        } else {
          this.$el.hide();
        }
      }
    },
    handleHelpKeydown: function handleHelpKeydown(ev) {
      if (ev.keyCode === 13) {
        $(ev.target).click();
      }
    },
    setDepthIndex: function setDepthIndex(depth) {
      this.$el.attr("depth", depth);
      this.$el.addClass('form-object-depth-' + depth);
    },
    setRowOdd: function setRowOdd() {
      this.$el.addClass('form-object-row-odd');
    },
    setRowEven: function setRowEven() {
      this.$el.addClass('form-object-row-even');
    },
    setRowFirst: function setRowFirst() {
      this.$el.addClass('form-object-row-first');
    },
    refresh: function refresh() {
      if (this._formObjectIsUnloaded || !this.isRendered()) {
        return;
      }
      this.render(true);
      this.getDelegate().setupChildrenViewProperties();
    },
    render: function render(rerenderContentOnly) {
      if (this._formObjectIsUnloaded) {
        return;
      }
      var delegate = this.getDelegate(),
        isGroup = delegate.getType() == "question",
        text = delegate.getText(),
        description = delegate.getDescription(),
        label = delegate.getLabel(),
        $label = null,
        $text = null,
        $desc = null,
        $helpText = null,
        that = this,
        isDesigner = this.isDesignerMode(),
        isDiffViewer = delegate.isDiffViewer(),
        templProps = delegate.getTemplateProperties();
      if (isDesigner) {
        this.refreshColor();
        this.$el.addClass("designer-mode");
      }
      this.$el.attr("id", delegate.getElementId());
      this.$el.addClass('form-object');
      this.$el.empty();
      this.$el.html(this.renderBaseFormObjectFragment(templProps));
      this.renderFormObject(templProps);
      if (isDesigner) {
        if (!this.isEmpty) {
          if (!rerenderContentOnly) {
            this.createSpacer();
          }
          this.renderInnerSpacer();
          $label = this.$('[data-property="label"]');
          $text = this.$('[data-property="text"]');
          $desc = this.$('[data-property="description"]');
          $helpText = this.$(".helptext-button");
          this.setLabelElement($label);
          this.setTextElement($text);
          this.setDescriptionElement($desc);
          this.setHelpTextElement($helpText);
          if (!rerenderContentOnly) {
            this.listenTo(delegate, 'change:label', function () {
              this.setLabelValue(delegate.getLabel());
            });
            this.listenTo(delegate, 'change:text', function () {
              this.setTextValue(delegate.getText());
            });
            this.listenTo(delegate, 'change:description', function () {
              this.setDescriptionValue(delegate.getDescription());
            });
            this.listenTo(delegate, 'change:helpText', function () {
              this.setHelpTextValue(delegate.getHelpText());
            });
          }
        }
      }
      if (delegate.getFormController().getActiveSection()) {
        var $section = delegate.getFormController().getActiveSection().getView().$el;
        this.$(".helptext-button").popover({
          container: $section,
          viewport: {
            selector: $section
          }
        });
      }
      var commentCountContainer;
      this._commentCountContainer = null;
      if (!isDesigner && !isDiffViewer) {
        this._commentCountContainer = commentCountContainer = $(document.createElement('div')).addClass('comment-container');
        if (delegate.shouldPutCommentContainerAfter()) {
          this.$('> .form-object-children-container').after(commentCountContainer.addClass('indent'));
        } else {
          this.$('> .form-object-contents .form-object-controls-container').append(commentCountContainer);
        }
        this.refreshCommentContainer();
      }
      this.listenToOnce(this, 'change:rendered', function () {
        this._animate = true;
      });
    },
    refreshCommentContainer: function refreshCommentContainer() {
      var delegate = this.getDelegate();
      if (this._commentCountContainer) {
        this._commentCountContainer.html(this.renderCommentCountFragment(delegate.getCommentProperties()));
      }
    },
    getCommentIconContainer: function getCommentIconContainer() {
      return this.$el.children('.form-object-contents').find('.comment-container');
    },
    setLabelValue: function setLabelValue(text) {
      this.getLabelElement().text(text);
    },
    setTextValue: function setTextValue(text) {
      this.getTextElement().html(text);
    },
    setDescriptionValue: function setDescriptionValue(description) {
      this.getDescriptionElement().html(description);
    },
    setHelpTextValue: function setHelpTextValue(helpText) {
      var el = this.getHelpTextElement();
      el.attr('data-content', helpText);
      if (helpText) {
        el.removeClass('empty-helptext');
      } else {
        el.addClass('empty-helptext');
      }
    },
    refreshColor: function refreshColor() {
      var delegate = this.getDelegate(),
        depth = delegate.getDepthIndex(),
        color = 8 * depth,
        rgb = this.constructor.baseColor.slice();
      rgb[0] = rgb[1] = rgb[2] -= color;
      this.$el.css('background-color', 'rgb(' + rgb.join(', ') + ')');
    },
    createSpacer: function createSpacer() {
      this.$el.before($(document.createElement("div")).addClass("form-object-spacer"));
    },
    renderInnerSpacer: function renderInnerSpacer() {
      var container = this.$('.form-object-children-container '),
        el = $(document.createElement("div")).addClass("form-object-spacer").addClass("last-internal");
      this._dropArea = el;
      container.append(el);
    },
    renderDropControls: function renderDropControls() {
      var container = this.$('.form-object-children-container '),
        frag = this.renderDropControlsFragment(),
        el = frag.children();
      this._dropArea = el;
      container.append(frag);
    },
    createChildElementBeforeEmpty: function createChildElementBeforeEmpty() {
      var container = $("<div />");
      this.$('.form-object-drop-area').prev().before(container);
      return container;
    },
    handleDeleteKeydown: function handleDeleteKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleDeleteClick(ev);
      }
    },
    handleDeleteClick: function handleDeleteClick(ev) {
      this.getDelegate().requestDelete();
    },
    handleSettingsClick: function handleSettingsClick(ev) {
      this.getDelegate().getFormController().requestPropertiesTab();
    },
    renderFormObject: function renderFormObject(templateProperties) {
      var temp = this.renderFormObjectContent(templateProperties);
      temp.children().find('.form-object-content-controls').html(this.renderFormObjectControls(templateProperties));
      this.getContentElement().html(temp);
      this.setupFormElement();
    },
    renderFormObjectControls: function renderFormObjectControls() {
      return '';
    },
    setupFormElement: function setupFormElement() {},
    getChildContainer: function getChildContainer() {
      return this.$el.children('.form-object-children-container');
    },
    getContentElement: function getContentElement() {
      return this.$el.children('.form-object-contents');
    },
    getValue: function getValue() {
      return false;
    },
    insertElementAtIndex: function insertElementAtIndex(element, index) {
      var children = this.getDelegate().getChildren();
      if (children.length == 0 || !children[index]) {
        this.$el.children('.form-object-children-container').children('.form-object-spacer.last-internal').before(element);
      } else {
        children[index].getView().$el.prev('.form-object-spacer:not(.last-internal)').before(element);
      }
    },
    detach: function detach() {
      this.$el.prev('.form-object-spacer').remove();
      this.$el.detach();
    },
    createCommentsContainer: function createCommentsContainer() {
      var delegate = this.getDelegate();
      this._commentsContainer = $('<div/>').addClass('comment-list-container');
      if (delegate.shouldPutCommentContainerAfter()) {
        this._commentsContainer.addClass('indent');
      }
      this._commentCountContainer.after(this._commentsContainer);
      return this._commentsContainer;
    },
    getCommentsContainer: function getCommentsContainer() {
      return this._commentsContainer;
    },
    handleCommentContainerKeyDown: function handleCommentContainerKeyDown(ev) {
      if (13 === ev.keyCode) {
        this.handleCommentContainerClick(ev);
      }
    },
    handleCommentContainerClick: function handleCommentContainerClick(ev) {
      var commentsController = this.getDelegate().getCommentsControllerInstance(),
        that = this;
      return commentsController.deferred.lastly(this.getDelegate().getFormController().loadingForPromise()).lastly(function () {
        that.$el.toggleClass('comments-open');
        return commentsController.toggle();
      }).then(function () {
        that.refreshCommentContainer();
      });
    },
    showCommentContainer: function showCommentContainer() {
      return this.handleCommentContainerClick();
    },
    unload: function unload() {
      this._formObjectIsUnloaded = true;
      this._super.apply(this, arguments);
    }
  }, {
    baseColor: [255, 255, 255]
  });
  module.exports = AbstractFormObjectView;
});

